export const erasmusLogos = [
  {
    id: "erasmus-plus",
    alt: "Erasmus+",
    src: {
      light: "/assets/images/logos/school-site/erasmus-plus.png",
      dark: "/assets/images/logos/school-site/erasmus-plus.png",
    },
    size: "md",
    height: 30,
    offset: {
      x: 0,
      y: 0,
    },
  },
  {
    id: "cwrkdiz",
    alt: "CWRKDiZ",
    src: {
      light: "/assets/images/logos/school-site/cwrkdiz.png",
      dark: "/assets/images/logos/school-site/cwrkdiz-dark.png",
    },
    size: "md",
    height: 30,
    offset: {
      x: 0,
      y: 0,
    },
  },
];